import Section from "../Section";
import Localization from "../global/Localization";

export default class Footer extends Section {
    constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);

        this.localization = new Localization(theme, element);
    }
}
